// removed by extract-text-webpack-plugin
module.exports = {"container":"hk-component-container"};